export const maxFontSize = 100;
